// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getEnlaces as listEnlacesAPI,
    getEnlace as getEnlaceAPI,
    addEnlace as addEnlaceAPI,
    updateEnlace as updateEnlaceAPI,
    deleteEnlace as deleteEnlaceAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { enlacesApiResponseError, enlacesApiResponseSuccess } from './actions';
import { EnlacesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getEnlace({ payload: { id } }) {
    try {
        const response = yield call(getEnlaceAPI, id );
        const enlaceItem = response.data.data;
        yield put(enlacesApiResponseSuccess(EnlacesActionTypes.GET_ENLACE, enlaceItem));
    } catch (error) {
        yield put(enlacesApiResponseError(EnlacesActionTypes.GET_ENLACE, error));
    }
}

function* addEnlace({payload:enlace}){
    try{
        const response = yield call(addEnlaceAPI,{...enlace})
        const enlaceItem = response.data
        yield put(enlacesApiResponseSuccess(EnlacesActionTypes.ADD_ENLACE,enlaceItem))
    } catch(error){
        yield put(enlacesApiResponseError(EnlacesActionTypes.ADD_ENLACE,error))
    }
}

function* updateEnlace({payload:enlace}){
    try{
        const response = yield call(updateEnlaceAPI,{...enlace})
        const enlaceItem = response.data.data
        yield put(enlacesApiResponseSuccess(EnlacesActionTypes.UPDATE_ENLACE,enlaceItem))
    }catch(error){
        yield put(enlacesApiResponseError(EnlacesActionTypes.UPDATE_ENLACE,error))
    }
}
function* deleteEnlace({payload:{id}}){
    try{
        const response = yield call(deleteEnlaceAPI,id)
        const enlaceItem = response.data.id
        yield put(enlacesApiResponseSuccess(EnlacesActionTypes.DELETE_ENLACE,enlaceItem))
    }catch(error){
        yield put(enlacesApiResponseError(EnlacesActionTypes.DELETE_ENLACE,error))
    }
}

/**
 * List contactos
 */
function* listEnlaces({payload:params}) {
    try {
        const response = yield call(listEnlacesAPI, { ...params });
        const listaEnlaces = response.data.data;
        yield put(enlacesApiResponseSuccess(EnlacesActionTypes.LIST_ENLACES, listaEnlaces));
    } catch (error) {
        yield put(enlacesApiResponseError(EnlacesActionTypes.LIST_ENLACES, error));
    }
}


export function* watchGetEnlace(): any {
    yield takeEvery(EnlacesActionTypes.GET_ENLACE, getEnlace);
}

export function* watchListEnlaces(): any {
    yield takeEvery(EnlacesActionTypes.LIST_ENLACES, listEnlaces);
}

export function* watchAddEnlace():any{
    yield takeEvery(EnlacesActionTypes.ADD_ENLACE,addEnlace)
}
export function* watchUpdateEnlace():any{
    yield takeEvery(EnlacesActionTypes.UPDATE_ENLACE,updateEnlace)
}
export function* watchDeleteEnlace():any{
    yield takeEvery(EnlacesActionTypes.DELETE_ENLACE,deleteEnlace)
}


function* enlacesSaga(): any {
    yield all([
        fork(watchGetEnlace),
        fork(watchListEnlaces),
        fork(watchAddEnlace),
        fork(watchUpdateEnlace),
        fork(watchDeleteEnlace),
    ]);
}

export default enlacesSaga;
